import {Popover} from "antd";
import {Heartbeat} from "@/utils/stateApiType";
import {StateItemText, UtxTime} from "@/utils/stateChange";

export default function HexaStateItem({name, statusList,}: { name: string, statusList: Heartbeat[], }) {

    function timeAgoLocal(dateString: string): string {
        if (!dateString) return 'Invalid date';

        // 统一格式：把 '-' 换成 '/'，把 'T' 换成 ' '
        const normalized = dateString.replace(/-/g, '/').replace('T', ' ');
        const [datePart, timePart] = normalized.split(' ');

        if (!datePart || !timePart) return 'Invalid date';

        const [year, month, day] = datePart.split('/').map(Number);
        const [hour, minute, second] = timePart.split(':').map(Number);

        // 检查解析结果
        if ([year, month, day, hour, minute, second].some(isNaN)) {
            return 'Invalid date';
        }

        // 构造为本地时间
        const date = new Date(year, month - 1, day, hour, minute, second);
        const now = new Date();

        const diff = now.getTime() - date.getTime();
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));

        // 小于1天 → 仍显示 "1 days ago"
        const displayDays = days < 1 ? 1 : days+1;

        return `${displayDays} days ago`;
    }

    const itemColor = (val: number) => {
        if (val === 1) {
            return 'text-[#3AC79D]'
        }
        if (val === 2 || val === 3) {
            return 'text-[#EEB826]'
        }
        return 'text-[#F55454]'
    }
    const itemBgColor = (val: number) => {
        if (val === 1) {
            return 'bg-[#3AC79D]'
        }
        if (val === 2 || val === 3) {
            return 'bg-[#EEB826]'
        }
        return 'bg-[#F55454]'
    }

    if (!statusList) {
        return <></>
    }


    return <div className={`w-full `}>
        <div className={` rounded-[10px] state-all-light `}>
            <div className={`flex justify-between items-center`}>
                <div className={`flex items-center`}>
                    <div className={` text-white text-lg font-semibold`}>{name}</div>
                </div>
                <div
                    className={` text-sm font-semibold text-[#3AC79C] `}>
                    Operational
                </div>
            </div>
            <div
                className={` h-[34px] flex items-center mt-4 ${statusList.length < 60 ? 'gap-[4px]' : 'gap-[2px]'} state-popover`}>
                {statusList.map((item, index) => (
                    <Popover key={item.time} placement="bottom" title={''} content={<div>
                        <div className={`font-semibold text-white`}>{new Date(item.time).toLocaleDateString()}</div>
                        <div
                            className={`${itemColor(item.status)} font-normal`}>{StateItemText(item.status)}</div>
                    </div>}>
                        <div
                            className={`w-[6px] h-full w-5px-636 w-3px-556 w-2px-436 ${itemBgColor(item.status)} `}></div>
                    </Popover>
                ))}
            </div>
            <div
                className={`flex justify-between text-[11px] mt-3 gap-14 text-sm font-normal text-[rgba(255,255,255,.45)]`}>

                <div className={`flex justify-between w-full`}>
                    <span>{timeAgoLocal(statusList[0].time)}</span>
                    <div>{((statusList.filter(item => item.status === 1).length / statusList.length) * 100).toFixed(2)}% uptime</div>
                    <span>Today</span>
                </div>
            </div>

        </div>
    </div>
}